import cn from "classnames";
import type {AppEmptyProps} from "./Empty.types";
import styles from "./Empty.module.scss";

export const getClassNames = (props: AppEmptyProps) => {
    return cn(
        styles.empty,
        props.className,
    );
};